/* eslint-disable jsx-a11y/alt-text */
import React, { useState, useEffect, useRef } from 'react'; // Asegurarse de importar React y hooks
import iconHamburger from '../icons/hamburger.svg';
import iconCross from '../icons/cross-icon.svg';
import iconTg1 from '../icons/tg-1.svg';
import iconX1 from '../icons/x-1.svg';
import { useAccount } from 'wagmi';
import { Link, useHistory } from 'react-router-dom'; // Importar useHistory si se usa
import formatNumber, { imageUrl, apiUrl, coinNames, projectName } from '../utils/constants.ts';
import { adminAddress } from '../utils/constants.ts';
import bannerVideo from '../assets/banner.mp4'; // Importar el video banner
import BellIcon from '../icons/bell.svg'; // Asume que tienes un icono de campana
//import { toast } from 'react-toastify'; // <-- Import toast
import 'react-toastify/dist/ReactToastify.css'; // <-- Import toast CSS if not already globally imported

// No importar '../styles/TopBar.css' si no existe

const TopBar = ({
    onUserSelected,
    notifications = [], // Default to empty array
    unreadNotificationCount = 0, // Default to 0
    onNotificationClick, // Receive click handler
    onClearAllNotifications, // Optional: Receive clear handler
    showBanner = false, // Nueva prop para controlar la visibilidad del banner
    onDisconnect, // Recibir función para desconectar wallet
    isMobile = false // Añadir prop para indicar si es dispositivo móvil
}) => {
    // --- ADDED: Log received props ---
    // console.log("[TopBar] Rendering. Props received:", { notifications, unreadNotificationCount, onNotificationClick: typeof onNotificationClick });
    // --- END ADDED ---
  const [isExpanded, setIsExpanded] = useState(false);
  const { address } = useAccount(); // Obtener la dirección conectada
  const [history, setHistory] = useState([]); // Estado para el historial del carrusel
  const [showNotifications, setShowNotifications] = useState(false);
  const notificationRef = useRef(null);
  const profileDropdownRef = useRef(null); // <-- Define profileDropdownRef

  // --- ADD LOG: Check props inside render ---
  // console.log(`[TopBar] Props check inside render - unreadNotificationCount: ${unreadNotificationCount}, notifications length: ${notifications.length}`);
  // --- END LOG ---

  const handleHamburgerClick = () => {
    setIsExpanded(!isExpanded);
  };

  // useEffect para manejar el cierre del menú en pantallas grandes
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) { // lg breakpoint
        setIsExpanded(false);
      }
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // useEffect para obtener el historial del carrusel
  useEffect(() => {
    const FetchData = async () => {
      try {
        const response = await fetch(`${apiUrl}/getHistory`, { method: 'GET' });
        const data = await response.json();
        if (!data.message && Array.isArray(data)) {
          // Mapear los datos recibidos al formato esperado
          const historyData = data.map(item => ({
            chainId: item.chainId,
            amount: item.amount,
            buyer: item.buyer,
            name: item.name,
            token: item.token,
            contract: item.contract,
            type: item.type,
            avatarUrl: item.avatarUrl // Asegúrate de que este campo exista o maneja su ausencia
          }));
          setHistory(historyData);
        } else {
          setHistory([]); // Limpiar si no hay datos o hay error
        }
      } catch (e) {
        console.error("Error fetching history:", e);
        setHistory([]); // Limpiar en caso de error de fetch
      }
    };

    FetchData(); // Cargar datos al montar
    const interval = setInterval(FetchData, 10000); // Recargar cada 10 segundos
    return () => clearInterval(interval); // Limpiar intervalo al desmontar
  }, []); // Ejecutar solo una vez al montar

  let currentPath = window.location.pathname;

  // Cerrar notificaciones al hacer clic fuera
  useEffect(() => {
    function handleClickOutside(event) {
        if (profileDropdownRef.current && !profileDropdownRef.current.contains(event.target)) {
            // Assuming you have a state like `isProfileDropdownOpen` and a setter `setIsProfileDropdownOpen`
            // setIsProfileDropdownOpen(false);
        }
        // Close notification dropdown
        if (notificationRef.current && !notificationRef.current.contains(event.target)) {
            setShowNotifications(false);
        }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
}, [profileDropdownRef, notificationRef]); // Añadir notificationRef

const handleNotificationClick = (notification) => {
    // console.log("[TopBar] Notification item clicked:", notification);
    if (typeof onNotificationClick === 'function') {
        onNotificationClick(notification); // Call the function passed from App.jsx/Profile.tsx
    } else {
        console.error("[TopBar] onNotificationClick is not a function!", onNotificationClick);
    }
    setShowNotifications(false); // Close dropdown after click
};

const toggleNotifications = () => {
    setShowNotifications(prev => !prev);
    // Optional: Mark all as read when opening? Or provide a separate button.
    // If marking all as read on open:
    // if (!showNotifications && onClearAllNotifications) { // Check if opening and handler exists
    //     onClearAllNotifications(); // Call handler to mark all as read in parent state
    // }
};

  // Añadir logs para debuggear conexión en móviles
  useEffect(() => {
    if (isMobile && address) {
      console.log(`[TopBar] Wallet conectada en móvil: ${address}`);
    }
  }, [address, isMobile]);

  // JSX completo restaurado
  return (
    // Envolver todo en un div para incluir el banner y la barra de navegación
    <div>
      {/* Contenedor original de la barra de navegación */}
      <nav className={`TopBarContainer relative ${isMobile ? 'mobile-topbar' : ''}`}> 
        {/* Carrusel de historial - Solo una instancia */}
        <div className="top-bar absolute top-0 left-0"> 
          {history.length > 0 ? (
            <div className='carousel-container'>
              <div className="carousel-track">
                {history.map(
                  ({ chainId, amount, buyer, name, token, contract, type, avatarUrl }, i) => (
                    <div className="carousel-card" key={`${contract}-${type}-${i}`}> 
                      <Link
                        className="top-bar-address"
                        to={'/profile/?address=' + buyer}
                        target={currentPath.includes('profile') ? '_blank' : ''}
                        rel="noreferrer"
                      >
                        {buyer.slice(0, 5) + '...' + buyer.slice(-3)}
                      </Link>
                      <span className={`text-${type === "bought" ? "green-500" : "red-500"} pl-1 pr-1`}>{type === "bought" ? "bought" : "sold"}</span>
                      <span className="top-bar-description">{formatNumber(Number(amount))} &nbsp;{type === 'bought' ? coinNames[chainId] : name?.length > 6 ? `${name.slice(0, 6)}...` : name || 'Token'}</span>
                      <Link
                        className="top-bar-address"
                        to={`/buy/?chain=${chainId}&address=${contract}`}
                        rel="noreferrer"
                      >
                        <img
                          src={`${imageUrl}logo/${projectName}-${chainId}-${contract}.png`}
                          width="24px"
                          height="24px"
                          alt={name || 'Token Logo'}
                          className="rounded-full top-bar-token-icon inline-block ml-1"
                          onError={(e) => { e.target.style.display = 'none'; }}
                        />
                      </Link>
                    </div>
                  )
                )}
              </div>
            </div>
          ) : (
            <div className='text-center text-gray-500 h-full flex items-center justify-center'>Loading history...</div>
          )}
        </div>

        {/* Barra principal */}
        {/* Ajustar 'top' para que quede debajo del carrusel */}
        <div className="absolute top-[40px] left-0 w-full z-50 px-2 bg-[#010101]"> {/* Ajustado top a 40px (altura del carrusel) */}
          <div className={`my-0 max-w-7xl m-auto w-full items-center ${isExpanded ? 'pb-2 px-2' : 'px-2'}`} >
            <div className='flex justify-between items-center h-[50px]'>
              <div className='flex flex-row items-center'>
                {/* Logo */}
                <Link to="/dashboard">
                  <img src="/img/logo.png" width="100px" alt="Logo" />
                </Link>
                {/* Menú Desktop */}
                <div className='hidden lg:flex flex-row gap-4 ml-5' style={{ fontFamily: "Bricolage Grotesque, sans-serif" }}>
                  {/* Enlaces del menú */}
                  <Link to="/dashboard" className="left-bar-link">
                    <span className={currentPath === '/' || currentPath === '/dashboard' ? 'text-[18px] text-[#45c0be]' : 'text-[18px] text-[#a0aec0] hover:text-[#45c0be]'}>Dashboard</span>
                  </Link>
                  <Link to="/create" className="left-bar-link">
                    <span className={currentPath === '/create' ? 'text-[18px] text-[#45c0be]' : 'text-[18px] text-[#a0aec0] hover:text-[#45c0be]'}>Create</span>
                  </Link>
                  <Link to="/streams" className="left-bar-link">
                    <span className={currentPath === '/streams' ? 'text-[18px] text-[#45c0be]' : 'text-[18px] text-[#a0aec0] hover:text-[#45c0be]'}>Streams</span>
                  </Link>
                  {address && ( // Mostrar solo si está conectado
                    <Link to={'/profile/?address=' + address} className="left-bar-link">
                      <span className={currentPath.includes('/profile') ? 'text-[18px] text-[#45c0be]' : 'text-[18px] text-[#a0aec0] hover:text-[#45c0be]'}>Profile</span>
                    </Link>
                  )}
                  <Link to="/referral" className="left-bar-link">
                    <span className={currentPath === '/referral' ? 'text-[18px] text-[#45c0be]' : 'text-[18px] text-[#a0aec0] hover:text-[#45c0be]'}>Referral</span>
                  </Link>
                  <Link to="/intel" className="left-bar-link">
                    <span className={currentPath === '/intel' ? 'text-[18px] text-[#45c0be]' : 'text-[18px] text-[#a0aec0] hover:text-[#45c0be]'}>About</span>
                  </Link>
                  {address === adminAddress && ( // Mostrar solo si es admin
                    <Link to="/admin" className="left-bar-link">
                      <span className={currentPath === '/admin' ? 'text-[18px] text-[#45c0be]' : 'text-[18px] text-[#a0aec0] hover:text-[#45c0be]'}>Admin</span>
                    </Link>
                  )}
                </div>
              </div>
              {/* Iconos sociales y botón de conexión */}
              <div className='flex flex-row items-center gap-4'>
                <div className='hidden sm:flex flex-row gap-2'>
                  <a href="https://x.com/" target="_blank" className="p-1 text-white" rel="noreferrer">
                    <img src={iconX1} className='w-[20px] h-[20px]' alt="X Icon"/>
                  </a>
                  <a href="https://t.me/" target="_blank" className="p-1" rel="noreferrer">
                    <img src={iconTg1} className='w-[20px] h-[20px]' alt="Telegram Icon"/>
                  </a>
                </div>
                {/* Botón de Web3Modal */}
                <div className={`navConnectButtonBox ${isMobile ? 'mobile-connect' : ''}`}>
                  <w3m-button /> {/* Este botón maneja el estado de conexión */}
                </div>
                {/* Botón Hamburguesa */}
                <button className='bg-[#45c0be] hover:bg-[#4683c0] rounded-full p-2 flex lg:hidden' onClick={handleHamburgerClick}>
                  <img src={isExpanded ? iconCross : iconHamburger} className='w-[24px] h-[24px]' alt="Menu toggle"/>
                </button>
                {/* Botón de Notificaciones */}
                <div className="relative" ref={notificationRef}>
                    <button onClick={toggleNotifications} className="relative p-2 rounded-full hover:bg-gray-700">
                        <img src={BellIcon} alt="Notifications" className="w-6 h-6 text-white" />
                        {unreadNotificationCount > 0 && (
                            <span className="absolute top-0 right-0 flex h-4 w-4 items-center justify-center rounded-full bg-red-500 text-xs font-bold text-white">
                                {unreadNotificationCount > 9 ? '9+' : unreadNotificationCount}
                            </span>
                        )}
                    </button>
                    {showNotifications && (
                        <div className={`absolute right-0 mt-2 ${isMobile ? 'w-[calc(100vw-20px)]' : 'w-72'} bg-gray-800 border border-gray-600 rounded-md shadow-lg z-20 max-h-96 overflow-y-auto`}>
                            {notifications.length === 0 ? (
                                <p className="text-gray-400 text-sm p-4 text-center">No new notifications</p>
                            ) : (
                                <ul>
                                    {notifications.map((notif) => (
                                        <li
                                            key={notif.id}
                                            onClick={() => handleNotificationClick(notif)}
                                            className={`px-4 py-3 text-sm border-b border-gray-700 last:border-b-0 cursor-pointer hover:bg-gray-700 ${!notif.read ? 'text-white font-medium' : 'text-gray-300'}`}
                                        >
                                            <p className="truncate">{notif.text}</p>
                                            <p className="text-xs text-gray-500 mt-1">{new Date(notif.timestamp).toLocaleString()}</p>
                                        </li>
                                    ))}
                                </ul>
                            )}
                            {notifications.length > 0 && onClearAllNotifications && (
                                <div className="p-2 border-t border-gray-700 text-center">
                                    <button
                                        onClick={() => {
                                            onClearAllNotifications();
                                        }}
                                        className="text-xs text-blue-400 hover:text-blue-300"
                                    >
                                        Mark all as read
                                    </button>
                                </div>
                            )}
                        </div>
                    )}
                </div>
              </div>
            </div>
            {/* Menú Móvil Expandido */}
            {isExpanded && (
              <div className='absolute top-[60px] left-0 w-full bg-[#050f1a] shadow-lg lg:hidden'
                   style={{ transform: "none", transformOrigin: "50% 50% 0px" }}>
                <div className='flex flex-col gap-4 px-4 py-5' style={{ fontFamily: "Kanit, sans-serif" }}>
                  {/* Enlaces del menú móvil */}
                  <Link to="/dashboard" className="left-bar-link" onClick={() => setIsExpanded(false)}>
                    <span className={currentPath === '/' || currentPath === '/dashboard' ? 'text-[18px] text-[#45c0be]' : 'text-[18px] text-[#a0aec0] hover:text-[#45c0be]'}>Dashboard</span>
                  </Link>
                  <Link to="/create" className="left-bar-link" onClick={() => setIsExpanded(false)}>
                    <span className={currentPath === '/create' ? 'text-[18px] text-[#45c0be]' : 'text-[18px] text-[#a0aec0] hover:text-[#45c0be]'}>Create</span>
                  </Link>
                  <Link to="/streams" className="left-bar-link" onClick={() => setIsExpanded(false)}>
                    <span className={currentPath === '/streams' ? 'text-[18px] text-[#45c0be]' : 'text-[18px] text-[#a0aec0] hover:text-[#45c0be]'}>Streams</span>
                  </Link>
                  {address && (
                    <Link to={'/profile/?address=' + address} className="left-bar-link" onClick={() => setIsExpanded(false)}>
                      <span className={currentPath.includes('/profile') ? 'text-[18px] text-[#45c0be]' : 'text-[18px] text-[#a0aec0] hover:text-[#45c0be]'}>Profile</span>
                    </Link>
                  )}
                  <Link to="/referral" className="left-bar-link" onClick={() => setIsExpanded(false)}>
                    <span className={currentPath === '/referral' ? 'text-[18px] text-[#45c0be]' : 'text-[18px] text-[#a0aec0] hover:text-[#45c0be]'}>Referral</span>
                  </Link>
                  <Link to="/intel" className="left-bar-link" onClick={() => setIsExpanded(false)}>
                    <span className={currentPath === '/intel' ? 'text-[18px] text-[#45c0be]' : 'text-[18px] text-[#a0aec0] hover:text-[#45c0be]'}>About</span>
                  </Link>
                  {address === adminAddress && (
                    <Link to="/admin" className="left-bar-link" onClick={() => setIsExpanded(false)}>
                      <span className={currentPath === '/admin' ? 'text-[18px] text-[#45c0be]' : 'text-[18px] text-[#a0aec0] hover:text-[#45c0be]'}>Admin</span>
                    </Link>
                  )}
                  {/* Iconos sociales en móvil */}
                  <div className='flex flex-row gap-4 pt-4 justify-center sm:hidden'>
                    <a href="https://x.com/" target="_blank" className="p-2" rel="noreferrer">
                      <img src={iconX1} className='w-[24px] h-[24px]' alt="X Icon"/>
                    </a>
                    <a href="https://t.me/" target="_blank" className="p-2" rel="noreferrer">
                      <img src={iconTg1} className='w-[24px] h-[24px]' alt="Telegram Icon"/>
                    </a>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </nav>

      {/* --- Sección del Banner de Video --- */}
      {/* Mostrar el banner solo si showBanner es true */}
      {showBanner && (
        <div className="w-full md:max-w-4xl mx-auto bg-black rounded-lg overflow-hidden mt-[20px] mb-[10px]">
          <video
            src={bannerVideo}
            autoPlay
            loop
            muted
            playsInline
            className="w-full h-auto max-h-[60px] object-cover"
          >
            Tu navegador no soporta el elemento de video.
          </video>
        </div>
      )}
      {/* --- Fin Sección del Banner de Video --- */}
    </div> // Cierre del div envolvente
  );
};

export default TopBar;

// Estilos CSS básicos para el carrusel (inyectados para simplicidad)
const styles = `
.top-bar {
  /* position: absolute; */ /* Podría necesitar ser relativo ahora */
  /* top: 0; */ /* Ajustar si es relativo */
  /* ... otros estilos ... */
  height: 40px; /* Altura de la barra superior */
  background-color: #0a192f; /* Color de fondo oscuro */
  overflow: hidden;
  border-bottom: 1px solid #31487b; /* Borde inferior */
  z-index: 40; /* Debajo de la barra principal */
  width: 100%; /* Asegurar ancho completo */
}

.carousel-container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
}

.carousel-track {
  display: flex;
  animation: scroll 60s linear infinite; /* Ajusta la duración según necesites */
  white-space: nowrap;
  height: 100%;
  align-items: center;
}

.carousel-card {
  display: inline-flex;
  align-items: center;
  padding: 0 15px;
  color: #a0aec0;
  font-size: 0.8rem;
  height: 100%;
  border-right: 1px solid #1c529033;
}

.carousel-card a {
  color: #45c0be;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
}

.carousel-card a:hover {
  text-decoration: underline;
}

.top-bar-token-icon {
  vertical-align: middle;
}

@keyframes scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%); /* Mover la mitad de la longitud total */
  }
}

/* Estilos adicionales para TopBar */
.TopBarContainer {
  position: relative;
  height: 90px; /* Reducir altura total (40px historial + 50px barra principal) */
}

.left-bar-link span {
  transition: color 0.2s ease-in-out;
}

/* Estilos para el botón de Web3Modal si necesitas personalización */
/* w3m-button { ... } */
`;

// Inyectar estilos en el head (o puedes ponerlos en un archivo CSS)
// Asegurarse de que esto no se ejecute múltiples veces si el componente se renderiza de nuevo
if (!document.getElementById('topbar-styles')) {
  const styleSheet = document.createElement("style");
  styleSheet.id = 'topbar-styles'; // Añadir ID para evitar duplicados
  styleSheet.type = "text/css";
  styleSheet.innerText = styles;
  document.head.appendChild(styleSheet);
}
